module.exports = __webpack_public_path__ + "img/stage_sonnenblume.a5546396.jpg";